import React from 'react';
import './button.styles.scss';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
}

const Button: React.FC<ButtonProps> = (props) => {
  return (
    <button {...props} title={props.label} className={(props?.className ?? '') + ' button'}>
      {props.label}
    </button>
  );
};

export default Button;
